import { useRouter } from 'next/router';

export const useOrgSlug = () => {
  const router = useRouter();
  const { orgSlug } = router.query;
  const organizationSlug = orgSlug as string;

  return { organizationSlug };
};
